import initPage from "../../../utils/initPage";
import t from "../../../i18n/i18n";

import DefRoutes from "../../../routes/routes.json";
import Template from "../../../template/template";
import Aside from "./aside/aside";
import PasswordForm from "./passwordForm/passwordForm";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useApi from "../../../services/api";
import { useSelector } from "react-redux";

function EditUserPassword() {
  initPage({ title: t("Profile.PasswordChangeTitle") });

  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState({});
  const { name } = useParams();
  const { ApiAdminGetUserByName } = useApi();

  const { logged, user: adminUser } = useSelector((store) => store.auth);

  useEffect(() => {
    const getUser = async () => {
      const { data } = await ApiAdminGetUserByName(name);

      if (!data) {
        return window.location.replace(DefRoutes.Home);
      }

      setLoading(false);
      setUser(data);
    };

    getUser();
  }, [ApiAdminGetUserByName, name]);

  if (!logged || !adminUser) {
    return (window.location = DefRoutes.SignIn);
  }

  const { admin } = adminUser;

  if (!admin) {
    return window.location.replace(DefRoutes.Home);
  }

  return (
    <Template>
      {!loading ? (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="inside-warp">
                <div className="col-sidebar">
                  <div className="mobile-side-btn">
                    <button type="button" className="side-toggle">
                      <i className="fal fa-cog"></i>
                    </button>
                  </div>
                  <div className="sidebar-main">
                    <Aside user={user} />
                  </div>
                </div>

                <div className="col-contentbar">
                  <div className="user-profile-form change-password">
                    <PasswordForm user={user} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ height: window.screen.height / 1.5 }} />
      )}
    </Template>
  );
}

export default EditUserPassword;
